import {forEach} from "../../js/helpers";

export function pane(item) {
  const content = item.querySelector('.pane__content');
  const header = item.querySelector('.pane__header');
  content.style.setProperty('--max-height', content.scrollHeight + 'px');
  if (item.classList.contains('inited')) return;
  header.addEventListener('click', () => {
    if (item.classList.contains('active')) {
      item.classList.remove('active');
    } else {
      forEach(document.querySelectorAll('.pane__header'), el => {
        el.parentNode.classList.remove('active')
      });
      item.classList.add('active');
    }
  });
  item.classList.add('inited');
}
